import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ElementRef, EventEmitter } from '@angular/core';

import { ContaService } from '../../shared/services/conta/conta.service';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';
import { PendenciasService } from '../../shared/services/pendencias/pendencias.service';
import { EventEmitterService } from '../../shared/services/event-emitter/event-emitter.service';
import {SituacaoContaEnum} from '../../shared/enums/SituacaoConta.enum';

declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  public paths: any[] = [];
  public routeTitle = '';

  public account = null;
  public accountId = null;

  public showModal = false;
  public showModalPayment = false;

  public isPendencia = false;

  constructor(
    private title: Title,
    private router: Router,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private contaService: ContaService,
    private localStorageService: LocalStorageService,
    private pendenciasService: PendenciasService
  ) { }

  ngOnInit() {
    EventEmitterService.get('close-register-modal').subscribe(() => {
      this.eventClose();
    });

    this.getPath(this.route);

    this.router.events.forEach(() => {
      this.paths = [];
      this.getPath(this.route);
    });

    this.getAccount();
  }

  getAccount() {
    this.accountId = this.localStorageService.get('login').PersonId;
   
    this.contaService.obterConta(this.accountId).subscribe((data: any) => {
      this.account = data;

      this.setPendencias();
    }, (err) => {
      console.error(err);
    });
  }

  setPendencias() {
    if (this.account && this.account.Pendencias) {
      this.account.Pendencias.forEach((pendencia) => {
        switch (pendencia.Valor) {
          case 'Identificacao':
          case 'Atividade':
          case 'Residencia':
          case 'Cnpj':
          case 'Adesao':
            this.isPendencia = true;
            break;
        }
      });
    }

    if (this.account.Situacao == SituacaoContaEnum.Bloqueada) {
      this.showModalPayment = true;
    } else {
      if (this.account && this.account.TipoCadastro === 'PagueLa' && (this.isPendencia || this.account.InformacoesBancarias.length === 0)) {
        this.showModal = true;
      }
    }
  }

  getPath(route) {
    if (
      route &&
      route.data &&
      route.data.value &&
      route.data.value.title
    ) {
      this.routeTitle = route.data.value.title;
      this.title.setTitle('Pague.lá | ' + route.data.value.title);
    }

    if (
      route &&
      route.data &&
      route.data.value &&
      route.data.value.breadcrumb &&
      route.data.value.link
    ) {
      this.paths.push({
        breadcrumb: route.data.value.breadcrumb,
        link: route.data.value.link,
        children: route.children.length > 0
      });
    }

    if (
      route &&
      route.children &&
      route.children.length > 0
    ) {
      this.getPath(route.children[0]);
    }
  }

  eventClose() {
    this.showModal = false;
  }

  editInput(e) {
    $(e.target).parent().find('input').removeAttr('disabled');
    $(e.target).hide();
  }

  cleanErrorClass(e) {
    if (e.target.value.length > 0) {
      $(e.target).parent().removeClass('has-error');
    } else {
      $(e.target).parent().addClass('has-error');
    }
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
    this.elRef.nativeElement.querySelector('.btn-registrar').setAttribute('disabled', 'disabled');
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').removeAttribute('disabled');
  }

  goToFatura(): void {
    this.showModalPayment = false;
    this.router.navigate(['/minha-conta/faturamento']).then();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.component.ts